<template>
  <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">المسؤولون المسجلون</h1>
        <p class="mt-2 text-sm text-gray-700"></p>
      </div>
    </div>
    <div class="mt-8 flex flex-col">
      <div class="sm:flex-auto">
        <h1 class="text-lg font-medium text-gray-900">المسؤولون</h1>
        <p class="mt-2 text-xs text-gray-700"></p>
      </div>
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-customHafadhColor">
              <thead class="bg-customHafadhColor text-center">
                <tr>
                  <th class="py-3.5 pr-4 pl-3 text-right text-sm font-semibold text-gray-900 sm:pr-6">#</th>
                  <th class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">الاسم</th>
                  <th class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">الايميل</th>
                  <th class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">تعديل</th>
                  <th class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">حذف</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="(admin, index) in admins" :key="admin.id">
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm text-gray-900 sm:pr-6">{{ index + 1 }}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ admin.fullName || admin.name }}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ admin.email }}</td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium sm:pr-6">
                    <button class="enabled-button" @click="openEditPopup(admin)">تعديل</button>
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium sm:pr-6">
                    <button class="text-red-600 hover:text-red-800" @click="deleteAdmin(admin.id)">حذف</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

 <!-- Edit Admin Popup -->
    <div v-if="showEditPopup" class="popup" dir="rtl">
      <div class="popup-content">
        <h3 class="text-lg leading-6 font-medium text-gray-900">تعديل المسؤول</h3>
        <div class="grid grid-cols-1 gap-4 mt-5">
          <!-- Full Name -->
          <div>
            <label for="fullName" class="block text-sm font-medium text-gray-700">الاسم الكامل</label>
            <input
              id="fullName"
              v-model="editAdmin.fullName"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <!-- Email -->
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">الايميل</label>
            <input
              id="email"
              v-model="editAdmin.email"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <!-- Password -->
          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">كلمة المرور</label>
            <input
              id="password"
              type="password"
              v-model="editAdmin.password"
              placeholder="اتركها فارغة إن لم تتغير"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <!-- National ID field removed as it's not essential for app functionality -->
          <!-- Phone -->
          <div>
            <label for="phone" class="block text-sm font-medium text-gray-700">رقم الجوال</label>
            <input
              id="phone"
              v-model="editAdmin.phone"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <!-- Qualification -->
          <div>
            <label for="qualification" class="block text-sm font-medium text-gray-700">المؤهل</label>
            <select
              id="qualification"
              v-model="editAdmin.qualificationId"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            >
              <option v-for="q in qualifications" :key="q.id" :value="q.id">{{ q.qualificationValue }}</option>
            </select>
          </div>
          <!-- Region -->
          <div>
            <label for="region" class="block text-sm font-medium text-gray-700">المنطقة</label>
            <select
              id="region"
              v-model="editAdmin.regionId"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            >
              <option 
              v-for="r in regions"
              :key="r.id" :value="r.id"
              >{{ r.regionNameAr }}</option>
            </select>
          </div>
        </div>

        <div class="mt-6 grid grid-cols-2 gap-3">
          <button
            class="enabled-button w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
            @click="submitEditAdmin"
          >
            حفظ
          </button>
          <button
            class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
            @click="closeEditPopup"
            type="button"
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import axios from 'axios'
import url from '@/url.js'

export default defineComponent({
  name: 'AllAdmins',
  data() {
    return {
      admins: [],
      qualifications: [],
      regions: [], 
      showEditPopup: false,
            editAdmin: {
        id: null,
        fullName: '',
        email: '',
        password: '',
        // nationalId: '', // Removed as it's not essential for app functionality
        phone: '',
        qualificationId: null,
        regionId: null
      }
    }
  },
  methods: {
    async loadAdmins() {
      try {
        const { data } = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_all_admins,
          { headers: { 'X-Authorization': localStorage.getItem('token') } }
        )
        this.admins = data.result?.data || data.data || data
      } catch (e) {
        console.error('Failed to load admins', e)
      }
    },
        async loadQualifications() {
      const { data } = await axios.get(
        process.env.VUE_APP_SERVICE_URL + url.master_qualifications,
        { headers: { 'X-Authorization': localStorage.getItem('token') } }
      )
      // assume the payload is in data.result.data (adjust if different)
      this.qualifications = data.result.data || []
    },
    async loadRegions() {
      const { data } = await axios.get(
        process.env.VUE_APP_SERVICE_URL + url.master_regions,
        { headers: { 'X-Authorization': localStorage.getItem('token') } }
      )
      this.regions = data.result.data || []
    },
    openEditPopup(admin) {
      this.editAdmin = { ...admin }
      this.showEditPopup = true
    },
    closeEditPopup() {
      this.showEditPopup = false
              Object.assign(this.editAdmin, { id: null, fullName: '', email: '', password: '', phone: '', qualificationId: null, regionId: null })
    },
    async submitEditAdmin() {
      try {
        await axios.put(process.env.VUE_APP_SERVICE_URL + url.update_admin + this.editAdmin.id ,
          {
            fullName: this.editAdmin.fullName,
            email: this.editAdmin.email.toLocaleLowerCase(),
            password: this.editAdmin.password || undefined,
            // nationalId: this.editAdmin.nationalId, // Removed as it's not essential for app functionality
            phone: this.editAdmin.phone,
            qualificationId: this.editAdmin.qualificationId,
            regionId: this.editAdmin.regionId
          },
          { headers: { 'X-Authorization': localStorage.getItem('token') } }
        )
        this.closeEditPopup()
        this.loadAdmins()
      } catch (e) {
        console.error('Edit failed', e)
      }
    },
    async deleteAdmin(id) {
      if (!confirm('هل أنت متأكد من حذف هذا المسؤول؟')) return
      try {
        await axios.post(process.env.VUE_APP_SERVICE_URL + url.delete_admin + id ,
          null,
          { headers: { 'X-Authorization': localStorage.getItem('token') } }
        )
        this.loadAdmins()
      } catch (e) {
        console.error('Delete failed', e)
      }
    }
  },
  mounted() {
    this.loadAdmins()
    this.loadQualifications()
    this.loadRegions()
  }
})
</script>

<style scoped>
.enabled-button {
  @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-20 h-10;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 540px;
  text-align: center;
}
</style>
